define('PartLookup.Assemblies.List.View', [
  'SCCollectionView',
  'PartLookup.Assemblies.Detail.View',
  'partlookup_diagrams.tpl',

  'PartLookup.PartList.View',

	'Backbone',
	'Configuration',
  'Utils',
	'underscore',

], function (
  SCCollectionViewModule,
  PartLookupAssembliesDetailView,
  partlookup_diagrams_tpl,

  PartLookupPartListView,

	Backbone,
	Configuration,
	Utils,
	_,
) {
  'use strict';

  var SCCollectionView = SCCollectionViewModule.SCCollectionView;

  function PartLookupAssembliesListView (options) {

    var collection = new Backbone.Collection();

    SCCollectionView.call(this, collection);
    
    this.collection = collection;
    this.template = partlookup_diagrams_tpl;
    this.model = options.model;
    this.application = options.application;

    var layout = options.application.getLayout();
    layout.once('afterAppendView', this.getAssemblyDiagrams, this);
  }

  PartLookupAssembliesListView.prototype = Object.create(SCCollectionView.prototype);

  _.extend(PartLookupAssembliesListView.prototype, {

    constructor: PartLookupAssembliesListView,

    getCellViewsPerRow: function() {
      return 10;
    },

    getCellViewInstance: function(model) {
      return new PartLookupAssembliesDetailView({
        model: model
      })
    },

    getChildViews: function() {

      return {
        'PartsList.View': function() {
          if ( !!this.model.get('selectedAssemblyId') ) {
            return new PartLookupPartListView({
              model: this.model,
              application: this.application,
              searchComponent: this.options.searchComponent
            });
          }
        }
      }
    },

    getAssemblyDiagrams: function() {

      var self = this;

      if ( !!this.model.get('modelSearchInput') ) {
        this.collection = new Backbone.Collection(
          _.map(self.model.get('modelAssemblies'), function (assembly) {
            return new Backbone.Model(assembly);
          })
        );
  
        this.render();
  
        var carousel = this.$el.find('[data-type="carousel-items"]');
  
        var siteSettings = this.application.getConfig().siteSettings;
        var imageSizeMapping = this.application.getConfig().imageSizeMapping;
  
        if (Utils.isPhoneDevice() === false && siteSettings.imagesizes) {
          var thumbnail = _.where(siteSettings.imagesizes, {
            name: imageSizeMapping.thumbnail,
          })[0];
  
          var img_min_height = thumbnail.maxheight;
  
          carousel
            .find('.modelsearch-diagram-thumbnail')
            .css('minHeight', img_min_height)
            .css('maxHeight', img_min_height);
        }
  
        var bxSliderConfigs = _.extend(Configuration.bxSliderDefaults, {
          maxSlides: 10,
        });
  
        Utils.initBxSlider(carousel, bxSliderConfigs);
      }

    },

    getContext: function() {
      //debugger;
      return {
        hasParts:!!this.collection.length,
        modelSearchInput: this.model.get('modelSearchInput')
      }
    }    
  });

  return PartLookupAssembliesListView;
});
